import api from './axios';

export const eventAPI = {
  // Get all active events
  getActiveEvents: async (registrationType = null) => {
    const params = registrationType ? { registrationType } : {};
    const response = await api.get('/events/active', { params });
    return response.data;
  },

  // Get event by ID
  getEventById: async (eventId) => {
    const response = await api.get(`/events/${eventId}`);
    return response.data;
  },
};
